<app-component-header
        (sidebar)="toggleSidebar($event)"
        offMenuIcons="true"
        style="z-index: 1000; position: relative;"
        type="twoSidebars"
>
    <ng-content select="[headerPanel]"></ng-content>
</app-component-header>


<div class="main">
    <div [class.open]="!closedLeftSidebar" class="left_block">
        <div (click)="closedLeftSidebar = !closedLeftSidebar" [class.closed]="closedLeftSidebar" class="left_icon">
            <i class="bi bi-list px-2"></i>
        </div>
        <div #leftSidebarNode>
            <ng-content select="[leftSidebar]"></ng-content>
        </div>
    </div>


    <div class="shadowed_block">
        <div [class.left_indent]="!closedLeftSidebar" [class.right_indent]="!closedRightSidebar" class="main_content">
            <ng-content></ng-content>
        </div>
    </div>


    <div [class.open]="!closedRightSidebar" class="right_sidebar">
        <div #rightSidebarNode>
            <ng-content select="[rightSidebar]"></ng-content>
        </div>
        <div (click)="closedRightSidebar = !closedRightSidebar" [class.closed]="closedRightSidebar" class="right_icon">
            <i class="bi bi-person-lines-fill px-2"></i>
        </div>
    </div>
</div>

<div (click)="hideSidebarByOverflow()" [class.open]="openLeftSidebar || openRightSidebar" class="overflow"></div>
